import React from "react";
import styles from "./style.scss";
import cn from "classnames";
import { CollectionAuthority } from "models/Auth";
import Pin from "images/icon/icn_pin_fill_16_unactive.svg";
import Copy from "images/icon/icn_copy_add.svg";
import Mail from "images/icon/mail_inspector_unset.svg";
import Share from "images/icon/share_unactive_16.svg";
import More from "images/icon/action_menu.svg";

interface Props {
  rows: number;
  type: "nikkei" | "personal";
  ipAuthFlg: boolean;
  authority: CollectionAuthority | null;
}

export const SkeletonLoading: React.FC<Props> = ({
  rows,
  type,
  ipAuthFlg,
  authority
}) => {
  return (
    <div className={styles.skeletonTableWrapper}>
      <div className={styles.table}>
        <table className={styles.vsTable}>
          <thead>
            <tr>
              {type !== "nikkei" || !ipAuthFlg ? (
                <th
                  className={type === "personal" ? styles.pin : styles.copy}
                ></th>
              ) : null}
              <th
                colSpan={type === "personal" ? (authority?.pinned ? 1 : 0) : 1}
                className={styles.name}
              >
                コレクション名
              </th>
              <th>説明文</th>
              <th
                className={
                  type === "personal" ? styles.corpPersonal : styles.corpNikkei
                }
              >
                コンテンツ
              </th>
              <th className={styles.date}>更新日</th>
              {type !== "nikkei" ? <th colSpan={3}></th> : null}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={`skeleton-row-${rowIndex}`}>
                {type !== "nikkei" || !ipAuthFlg ? (
                  <td
                    className={type === "personal" ? styles.pin : styles.copy}
                  >
                    <div
                      className={cn(
                        styles.tdContainer,
                        styles.alignCenter,
                        styles.justifyCenter
                      )}
                    >
                      <img src={type === "personal" ? Pin : Copy} />
                    </div>
                  </td>
                ) : null}
                <td
                  colSpan={
                    type === "personal" ? (authority?.pinned ? 1 : 0) : 1
                  }
                >
                  <div className={cn(styles.tdContainer, styles.alignCenter)}>
                    <div className={styles.text} />
                  </div>
                </td>
                <td>
                  <div className={cn(styles.tdContainer, styles.alignCenter)}>
                    <div className={styles.text} />
                  </div>
                </td>
                <td>
                  <div className={cn(styles.tdContainer, styles.alignCenter)}>
                    <div className={styles.text} />
                  </div>
                </td>
                <td>
                  <div className={cn(styles.tdContainer, styles.alignCenter)}>
                    <div className={styles.text} />
                  </div>
                </td>
                {type !== "nikkei" && authority?.mailAlert && (
                  <td className={styles.mail}>
                    <div
                      className={cn(
                        styles.tdContainer,
                        styles.alignCenter,
                        styles.justifyCenter
                      )}
                    >
                      <img src={Mail} alt="mail" />
                    </div>
                  </td>
                )}
                {type !== "nikkei" && authority?.share && (
                  <td className={styles.share}>
                    <div
                      className={cn(
                        styles.tdContainer,
                        styles.alignCenter,
                        styles.justifyCenter
                      )}
                    >
                      <img src={Share} alt="share" />
                    </div>
                  </td>
                )}
                {type !== "nikkei" && (
                  <td className={styles.operator}>
                    <div
                      className={cn(
                        styles.tdContainer,
                        styles.alignCenter,
                        styles.justifyCenter
                      )}
                    >
                      <img src={More} alt="more" />
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles.scrollBar} />
    </div>
  );
};
